import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import TtsCall from './pages/TtsCall';
import TtsSurvey from './pages/TtsSurvey';
import DispatchCall from './pages/DispatchCall';
import SmsSend from './pages/SmsSend';
import CallHistory from './pages/CallHistory';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import About from './pages/About';
import './styles/global.css';
import './styles/common.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tts-call"
                element={
                  <ProtectedRoute>
                    <TtsCall />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tts-survey"
                element={
                  <ProtectedRoute>
                    <TtsSurvey />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dispatch-call"
                element={
                  <ProtectedRoute>
                    <DispatchCall />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sms-send"
                element={
                  <ProtectedRoute>
                    <SmsSend />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/call-history"
                element={
                  <ProtectedRoute>
                    <CallHistory />
                  </ProtectedRoute>
                }
              />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/support" element={<Support />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
